import styled from 'react-emotion';
import NavButton from '../../NavButton/NavButton';

export const MultiZoomButtonsWrap = styled('div')`
  display: flex;
  position: absolute;
  bottom: 2%;
  gap: 0.5em;
`;

export const MultiZoomButton = styled(NavButton)`
  z-index: 1;
`;
